"use client";

import { AntdRegistry } from "@ant-design/nextjs-registry";
import { ConfigProvider } from "antd";

// Dealer Rack brand green as the Ant Design primary/info color so toasts,
// buttons, selects, pagination, etc. match the rebrand instead of antd blue.
const dealerRackTheme = {
  token: {
    colorPrimary: "#7EBC26",
    colorInfo: "#7EBC26",
    colorLink: "#588619",
    colorLinkHover: "#6AA31E",
  },
};

export default function AntdStyleRegistry({ children }: { children: React.ReactNode }) {
  return (
    <AntdRegistry>
      <ConfigProvider theme={dealerRackTheme}>{children}</ConfigProvider>
    </AntdRegistry>
  );
}
